<template>
  <div class="topWraper">
    <p class="logoWraper fl">
      <img src="static/image/jyzxLogo.png" alt="" class="logo">
    </p>
    <p class="leftTitle fl">{{title}}心理健康管理系统</p>
    <img src="static/image/tuichu.png" alt="" class="iconfont fr pointer relative" @click="tuichu" style="z-index: 100000000;">
    <div class="relative fr iconfont" style="width: 24px;height: 24px;margin-top: 20px;margin-right: 24px;">
      <img src="static/image/kefu.png" alt="" style="width: 100%;">
      <el-popover
          placement="top-start"
          trigger="hover"
          style="position: absolute;left: 0;top: 0;opacity: 0;z-index: 1000;width: 24px;height: 24px;box-sizing: border-box;">
          <img src="static/image/erweima.png" alt="" class="erweima" style="display: block;width: 140px;margin: 0 auto;">
          <el-button slot="reference" style="width: 24px;height: 24px;box-sizing: border-box;padding: 0;">hover 激活</el-button>
        </el-popover>
    </div>
  </div>
  </div>
</template>

<script>
  // var  confirm = ELEMENT.confirm;
  import http from '@/assets/request.js'
  export default {
    name: 'test',
    data() {
      return {
        title:title
      }
    },
    created() {

    },
    methods: {
      tuichu() {
        ELEMENT.MessageBox.confirm('确定要退出吗？', '确认信息', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {

            http.del('/authorizations/current',(res)=>{
              this.$store.commit("clearAll", '');
              sessionStorage.clear();
              this.$router.push({
              	path: '/login'
              });
            },(res)=>{
              this.$router.push({
              	path: '/login'
              });
            })
          }).catch(action => {

          });
      }
    }
  }
</script>

<style scoped>
  .topWraper {
    position: fixed;
    left: 0;
    top: 0;
    height: 70px;
    background: #E5E9F5;
    z-index: 2;
    width: 100%;

  }

  .leftTitle {
    font-size: 20px;
    line-height: 70px;
    color: #fff;
    padding-left: 30px;
    display: inline-block;
    color: #2760A8;
  }

  .iconfont {
    margin-right: 24px;
    display: block;
    margin-top: 23px;
    height: 24px;
    width: 24px;
  }
  .logoWraper{
    width: 180px;
    height: 70px;
    background-color: #E5E9F5;
  }
  .logo{
    display: block;
    margin: 0 auto;
    height: 62px;
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/topBar.vue